import { Component, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AutofocusIonicFieldInputProps } from '@ts/shared/form/focus/util-ionic';
import { SharedFormWrapperUiIonFormFieldModule } from '@ts/shared/form/wrapper/ui-ion-form-field';

import { InputFieldComponent } from '../input/input-field.component';

@Component({
  selector: 'ts-password-field',
  styleUrls: ['./password.field.component.scss'],
  templateUrl: './password.field.component.html',
  imports: [
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    SharedFormWrapperUiIonFormFieldModule,
    TranslocoModule,
    InputFieldComponent,
  ],
})
export class PasswordFieldComponent extends FieldType<FieldTypeConfig> {
  @ViewChild(InputFieldComponent) inputFieldComponent!: InputFieldComponent;

  /**
   * Whether the user has pressed the eye button and the password is shown to user.
   */
  isPasswordShown = false;

  getInputFieldProps(): AutofocusIonicFieldInputProps {
    return {
      ...this.props,
      type: this.isPasswordShown ? 'text' : 'password',
    };
  }

  setFocus() {
    this.inputFieldComponent.setFocus();
  }
}
